function n(o,...r){console.warn(o,...r)}function a(o,...r){console.error(o,...r)}export{a as logError,n as logWarning};
